import { Directive, HostListener } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { MapService } from '../../services/map/map.service';

@Directive({
  selector: '[backButton]'
})
export class BackButtonDirective {

  constructor(
    public navigationService: NavigationService,
    private mapService: MapService
  ) { }

  @HostListener('click', ['$event'])
  onClick($event) {
    this.navigationService.back()
    this.mapService.removeAllLineStringMarkers();
    // this.router.navigate(['../'], { relativeTo: this.route })

    // dashboard/settings/generic-types
    // this.router.navigate(['dashboard', 'settings', 'generic-types'])
  }

  @HostListener('mouseenter') onMouseEnter() {
  }

}
